import { formatDuration, Locale } from 'date-fns';

import { parseISO8601Duration } from '~/core/helpers/date/parse-iso-duration/parse-iso-duration.helper';

export function formatIsoDuration(
  iso8601Duration: string,
  locale: Locale,
  twoDaysSplit = false
): string {
  if (!iso8601Duration) {
    return;
  }
  const parsedPeriod = parseISO8601Duration(iso8601Duration).duration;

  // If twoDaysSplit is true and duration is bigger than 2, show hour format (like "48 hours" instead of "2 days")
  if (twoDaysSplit && parsedPeriod.days <= 2) {
    // force hours in increments to 24h (24h, 48h, of days display if bigger)
    parsedPeriod.hours = parsedPeriod.days * 24 || 24;
    parsedPeriod.days = 0;
  }

  return formatDuration(parsedPeriod, { locale });
}
